export enum TYPE_ROUTE_ENUM{
    HOME = "HOME",
    CARD_INFO = "CARD_INFO",
    CARD_LINK = "CARD_LINK",
    CARD_TEXT= "CARD_TEXT",
    CARD_SUGGESTION="CARD_SUGGESTION"
}